import { FC, useEffect } from 'react';
import Button from '../../../../../components/Button/Button';
import LoadingSpinner from '../../../../../components/Button/LoadingSpinner/LoadingSpinner';
import { showToast } from '../../../../../components/Toast/Toast';
import { ToastTypes } from '../../../../../components/Toast/Toast.types';
import Tooltip from '../../../../../components/Tooltip/Tooltip';
import { PositionTypes } from '../../../../../components/Tooltip/Tooltip.types';
import { useAllFreezesForBundle } from '../../../../../services/bundles/bundles.service';
import FreezeCard from './FreezeCard/FreezeCard';
import styles from './FreezeDetails.module.css';
import { FreezeDetailsProps } from './FreezeDetails.types';
import { useTranslation } from 'react-i18next';

const FreezeDetails: FC<FreezeDetailsProps> = ({ bundleId, bundleData, openCreateWizard }) => {
  const { t } = useTranslation();
  const { data, isLoading, isError, isFetched } = useAllFreezesForBundle(bundleId !== undefined, bundleId!);
  const freezes = data?.data || [];
  const isLinkedBundle = !!bundleData?.linkedBundleName;
  const renderFreezeCards =
    freezes.length > 0
      ? freezes.map((freeze) => <FreezeCard key={freeze.id} {...freeze} bundleData={bundleData} />)
      : null;

  useEffect(() => {
    if (isError) showToast({ toastType: ToastTypes.Error, label: t('error.fetchingFreezeData'), id: 'freezeError' });
  }, [isError]);

  if (bundleId === undefined) return null;
  if (isLoading || (isFetched && freezes.length === 0))
    return (
      <div className={styles.container}>
        <div className={styles.headerWithTooltip}>
          <h2 className={styles.heading}>{t('editBundle.freezes.header')}</h2>
          <Tooltip content={t('editBundle.freezes.tooltip')} position={PositionTypes.Top} />
        </div>
        <div className={styles.emptyState}>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              <div className={styles.emptyStateMessage}>
                {isLinkedBundle
                  ? t('editBundle.freezes.linkedBundlesSupport')
                  : t('editBundle.freezes.noScheduledFreezeDates')}
              </div>
              <Button onClick={openCreateWizard} disabled={isLinkedBundle}>
                {t('editBundle.freezes.newFreezeButton')}
              </Button>
            </>
          )}
        </div>
      </div>
    );
  return (
    <div className={styles.container}>
      <div className={styles.titleRow}>
        <div className={styles.headerWithTooltip}>
          <h2 className={styles.heading}>{t('editBundle.freezes.freezeDatesHeader')}</h2>
          <Tooltip content={t('editBundle.freezes.freezeDatesTooltip')} position={PositionTypes.Top} />
        </div>
        <Button onClick={openCreateWizard} disabled={isLinkedBundle}>
          {t('editBundle.freezes.newFreezeButton')}
        </Button>
      </div>
      {renderFreezeCards}
    </div>
  );
};

export default FreezeDetails;
